const classNames = [

	'careerum-club5-header',
	'careerum-header-placeholder',
	'careerum-en-header',
    'careerum-en-header-tablet',
    'careerum-en-header-mobile',

    'careerum-club5-main',
    'careerum-club5-experience',
    'careerum-club5-myths',
    'careerum-club5-career',
    'careerum-club5-founder',
    'careerum-club5-form',
    'careerum-club5-what',
    'careerum-club5-space',
    'careerum-club5-start',
    'careerum-club5-we-learn',
    'careerum-club5-got',
    'careerum-club5-places',
    'careerum-club5-professions',
    'careerum-club5-results',
    'careerum-club5-how',
    'careerum-club5-track',
    'careerum-club5-calendar',
    'careerum-club5-team',
    'careerum-club5-tariffs',
    'careerum-club5-closed',
    'careerum-club5-question',
    'careerum-club5-help-buy',
    'careerum-club5-woman',
    'careerum-club5-opportunities',
    'careerum-club5-program',
    'club5-tariffs-item',
    'club5-tariffs-switchers',

	'careerum-club40-main',
    'careerum-club40-main-tablet',
    'careerum-club40-main-mobile',

	'careerum-club40-main2',
	'careerum-club40-achievements',

	'careerum-club40-about',
    'careerum-club40-about-tablet',
    'careerum-club40-about-mobile',

	'careerum-club40-goals',
    'careerum-club40-goals-tablet',
    'careerum-club40-goals-mobile',

	'careerum-club40-clients',
    'careerum-club40-clients-tablet',
    'careerum-club40-clients-mobile',

	'careerum-club40-mission',
    'careerum-club40-mission-tablet',
    'careerum-club40-mission-mobile',

	'careerum-club40-author',
    'careerum-club40-author-tablet',
    'careerum-club40-author-mobile',

	'careerum-club40-time',
    'careerum-club40-time-tablet',
    'careerum-club40-time-mobile',

	'careerum-club40-tariffs',
    'careerum-club40-tariffs-tablet',
    'careerum-club40-tariffs-mobile',
	'club40-tariffs2',
    'club40-tariffs2-tablet',
    'club40-tariffs2-mobile',
    
	'careerum-club40-results',
	'careerum-club40-banner-top',
	'careerum-club40-goals-slider',
	'careerum-club40-schedule',

	'careerum-club40-support',
    'careerum-club40-support-tablet',
    'careerum-club40-support-mobile',
    
	'club40-support2',
    'club40-support2-tablet',
    'club40-support2-mobile',

	'careerum-club40-form',
    'careerum-club40-form-tablet',
    'careerum-club40-form-mobile',

	'careerum-club40-banner1',
    'careerum-club40-banner1-tablet',
    'careerum-club40-banner1-mobile',

	'careerum-course40-main',
    'careerum-course40-main-tablet',
    'careerum-course40-main-mobile',

	'careerum-course40-about',
    'careerum-course40-about-tablet',
    'careerum-course40-about-mobile',

	'careerum-course40-results',
    'careerum-course40-results-tablet',
    'careerum-course40-results-mobile',

	'careerum-course40-banner1',
    'careerum-course40-banner1-tablet',
    'careerum-course40-banner1-mobile',

	'careerum-course40-banner2',

	'careerum-course40-tariffs',
    'careerum-course40-tariffs-tablet',
    'careerum-course40-tariffs-mobile',


    'careerum-popup',
    'careerum-club40-popup-pay',
    'careerum-club40-popup-pay2',
    'careerum-club40-popup-lk',
    'careerum-club40-popup-subscribe',
    'careerum-club40-popup-subscribe2',
    'careerum-club40-popup-thanks',
    'careerum-club40-popup-thanks2',
	'no-cabinet',
	'has-cabinet',
    'club40-time-item',
    'club40-tariffs-item',
    'course40-tariffs-item',
    'club40-goals-form',
    'blackfriday-tale-change-currency',
    'trip-tale-change-currency',

    'careerum-blackfriday-main',
    'careerum-blackfriday-tales',
    'careerum-blackfriday-mini',
    'careerum-blackfriday-form',
    'careerum-blackfriday-banner',
    'careerum-blackfriday-popup',
    'careerum-gift',

    'careerum-veb4-main',
    'careerum-veb4-problems',
    'careerum-veb4-form',
    'careerum-veb4-reviews',
    'careerum-veb4-buy',

    'careerum-product-main',
    'careerum-product-for',
    'careerum-product-about',
    'careerum-product-form',
    'careerum-product-how',
    'careerum-product-results',
    'careerum-product-news',
    'careerum-product-additional',
    'careerum-product-reviews',
    'careerum-product-tariffs',
    
    'careerum-quiz-main',
    
    'careerum-consultations4-main',
    'careerum-consultations4-couch',
    'careerum-consultations4-experts',
    'careerum-consultations4-tariffs',
    'careerum-consultations4-contacts',
    'consultations4-tariffs-item',
    'careerum-consultations4-about',
    'careerum-consultations4-how',
    'careerum-consultations4-results',
    
    'careerum-intens4-main',
    'careerum-intens4-for',
    'careerum-intens4-how',
    'careerum-intens4-banner',
    'careerum-intens4-study',
    'careerum-intens4-programm',
    'careerum-intens4-results',
    'careerum-intens4-cases',
    'careerum-intens4-subscribe',
    'careerum-intens4-boost',
    'careerum-intens4-photos',
    'careerum-intens4-quiz',

    'careerum-trip-main',
    'careerum-thanks4-main',
    
    'careerum-cv-main',
    'careerum-cv-who',
    'careerum-cv-why',
    'careerum-cv-power',
    'careerum-cv-format',
    'careerum-cv-schedule',
    'careerum-cv-experts-why',
    'careerum-cv-feedback',
    'careerum-cv-results',
    'careerum-cv-experts',
    'careerum-cv-header',
    'careerum-cv-clients',
    'careerum-cv-reviews',
    'careerum-cv-tariffs',
    'careerum-cv-pay',
    'careerum-cv-start',

    'careerum-affirm-main',
    'careerum-diagnostics-main',
    'careerum-validator-main',
    'careerum-validator-items',
    'careerum-career-main',
    'careerum-veb41-main',
    'careerum-veb41-tariff',
    'veb41-clients',
    'veb41-clients-tablet',
    'veb41-clients-mobile',
    'veb41-price-wrapper',
    'careerum-club40-popup-pay-tales',

    'careerum-course41-main',
    'careerum-course41-about-you',
    'careerum-course41-statistic',
    'careerum-course41-money',
    'careerum-course41-why',
    'careerum-course41-cta',
    'careerum-course41-after',
    'careerum-course41-author',
    'careerum-course41-program',
    'careerum-course41-instruments',
    'careerum-course41-live',
    'careerum-course41-form',
    'careerum-course41-static-reviews',
    'careerum-course41-reviews',
    'careerum-course41-about',
    'course41-tariffs',
    'club40-banner-self-esteem',
    
    'careerum-case3-main',
    'careerum-case3-content',

    'careerum-seo-main',
    'careerum-seo-who',
    'careerum-seo-you',
    'careerum-seo-results',
    'careerum-seo-tales',
    'careerum-seo-about',
    'careerum-seo-form',
    'careerum-seo-author',
    'careerum-seo-program',
    'careerum-seo-cases',
    
    'careerum-club40-who',
    'careerum-club40-programs',
    'careerum-club40-form2',
    'careerum-club40-author2',
    'careerum-club40-experts',
    'careerum-club40-career_consult',
    'careerum-club40-process',
    'careerum-club40-coming_soon',
    'careerum-club40-form3',

    'careerum-awake-main',
    'careerum-awake-schedule',
    'careerum-awake-telegram',
    'careerum-awake-new_programms',
    'careerum-awake-lesson',
    'careerum-awake-programms',
    'careerum-awake-master',
    'careerum-awake-course',
    'careerum-awake-updates',
    'careerum-awake-lab',
    'careerum-awake-platform',
    'careerum-awake-pay',
    'careerum-awake-mobile',
    'careerum-awake-couches',
    'careerum-awake-tariffs',

    'awake-tariffs-item',
    'awake-reviews-item',

    'careerum-club50-main',
    'careerum-club50-main_sept',
    'careerum-club50-what',
    'careerum-club50-clients',
    'careerum-club50-clients2',
    'careerum-club50-for-you',
    'careerum-club50-cases',
    'careerum-club50-library',
    'careerum-club50-reviews',
    'careerum-club50-form',
    'careerum-club50-scanner',
    'careerum-club50-couches',
    'club50-couches2',
    'careerum-club50-tariffs',

    'club50-library-item',

    'careerum-validator2-main',
    'careerum-validator2-how',
    'careerum-validator2-form',
    'careerum-lead2-form',
    'careerum-pack-form',
    'careerum-pack2-form',
    'careerum-pack3-form',
    'pack-form-bottom',
    
    'careerum-club50-banner',
    'careerum-club50-schedule2',
    'careerum-club50-platform',
    'careerum-club50-community',
    'careerum-club50-scanner2',
    'careerum-club50-pay',
    'careerum-club50-faq',
    'careerum-club50-popup-question',
    'careerum-club5-banner-top',
    'careerum-club5-banner-top-timer',
    'careerum-intens5-form',
    'club5-banner-top3',
    'careerum-club50-club',
    'careerum-veb50-main',
    'careerum-veb50-form',
    'careerum-veb50-reviews',
    'careerum-birthday-main',
    'careerum-birthday-why',
    'careerum-birthday-form',
    'careerum-veb50-who',
    'careerum-realme50-main',
    'careerum-realme50-experience',
    'careerum-realme50-myths',
    'careerum-realme50-career',
    'careerum-realme50-calendar',
    'careerum-realme50-results',
    'careerum-realme50-reviews',
    'careerum-club50-about-subscription',
    'popup-faq-v1',
    'popup-faq-v2',
    'popup-faq-v3',
    'popup-faq-v4',
    'careerum-blackfriday2-main',
    'careerum-blackfriday2-content',
    'careerum-blackfriday2-form',
    'blackfriday2-content-slider-wrapper',
    'careerum-bfsale-main',
    'careerum-bfsale-map',
    'careerum-bfsale-labs',
    'careerum-bfsale-labs-about',
    'careerum-bfsale-description',
    'careerum-bfsale-tariffs',
    'careerum-bfsale-popup',
    'careerum-bfsale-popup-pay',
    'bfsale-description-bottom',
    'bfsale-description-item',
    'bfsale-tariffs-item',
    'careerum-advent2-main',
    'careerum-advent2-slider',
    'careerum-advent2-bonuses',
    'careerum-advent2-map',
    'careerum-advent2-support',
    'careerum-advent2-form',
    'careerum-advent-popup',
    'careerum-case4-main',
    'careerum-club50-system',
    'careerum-club50-banner2',
    'club5-banner-top4',
    'careerum-levelup-main',
    'careerum-levelup-foryou',
    'careerum-levelup-author',
    'careerum-levelup-newformats',
    'careerum-levelup-program',
    'careerum-levelup-format',
    'careerum-levelup-schedule',
    'careerum-levelup-pay',
    'careerum-levelup-author-popup',
    'careerum-levelup-banner',
    'careerum-candidate-main',
    'careerum-candidate-foryou',
    'careerum-club0326-main',
    'careerum-club0326-strategies',
    'careerum-club0326-system',
    'careerum-club0326-club',
    'careerum-club0326-selection',
    'careerum-veb0326-main',
    'careerum-veb0326-who',
    'careerum-veb0326-bonus',
    'careerum-veb0326-gift',
    'careerum-veb0326-program',
    'careerum-veb0326-promises',
    'careerum-veb0326-after',
    'careerum-consult0326-main',
    'careerum-consult0326-why',
    'careerum-consult0326-format',
    'careerum-consult0326-tariffs',
    'careerum-consult0326-faq',
    'careerum-club0426-main',
    'careerum-ai042026-main',
    'careerum-ai042026-authors',
    'careerum-ai042026-banner',
    'careerum-ai042026-why',
    'careerum-ai042026-program',
    'careerum-ai042026-format',
    'careerum-ai042026-result',
    'careerum-ai042026-pay',
    'careerum-ai042026-reviews',
    'careerum-ai042026-linkedin',
    'careerum-pack4-form',
    'careerum-bigpack-banner',
    'bigpack-banner-top',
    'careerum-pack5-main',
    'pack5-format',
    'careerum-pack5-form',
    'careerum-pack5-item',

    'careerum-gambit-main',
    'careerum-gambit-news',
    'careerum-gambit-team',
    'careerum-gambit-popular',
    'careerum-gambit-subscribe',
    'careerum-gambit-popup',
    'careerum-gambit-breadcrumbs',
    'careerum-gambit-intro',
    'careerum-gambit-content',

    'careerum-club0526-main',
    'careerum-club0526-why',
    'careerum-club0526-banner',
    'careerum-club0526-banner2',
    'careerum-club0526-example',
    'realme-banner-top',
    'careerum-levelup0726-main',
    'careerum-realme0726-compas',
    'careerum-levelup0726-form',
    'levelup0726-author',
    'careerum-levelup0726-main',
    'careerum-realme0726-compas',
    
    'careerum-career0726-main',
    'careerum-career0726-author',
    'careerum-career0726-about',
    'careerum-career0726-what',
    'careerum-career0726-tariffs',
    
    'careerum-reviews0726-main',
    'careerum-reviews0726-about',
    'careerum-reviews0726-pros',
    'careerum-reviews0726-reviews',
    'careerum-reviews0726-subscription',
    'careerum-reviews0726-faq',
    'careerum-reviews0726-join',
    'careerum-reviews0726-results',
    'careerum-reviews0726-rating',

    'careerum-global-main',
    'careerum-global-who',
    'careerum-global-why',
    'careerum-global-author',
    'careerum-global-how',
    'careerum-global-structure',
    'careerum-global-tariffs',
    'careerum-global-format',
    'careerum-global-banner',
    'careerum-global-banner-top',
    'careerum-global-main2',
    'careerum-global-why2',
    'careerum-global-learn',
    'careerum-global-result',
    'careerum-global-reviews',

    'careerum-globalmk-main',
    'careerum-globalmk-who',
    'careerum-globalmk-program',
    'careerum-globalmk-form',
    'careerum-globalmk-author',
    'careerum-globalmk-reviews',
    
    'careerum-media-kit-nav',
    'careerum-media-kit-hero',
    'careerum-media-kit-audience',
    'careerum-media-kit-topics',
    'careerum-media-kit-media',
    'careerum-media-kit-value',
    'careerum-media-kit-bio',
    'careerum-media-kit-photos',
    'careerum-media-kit-contact',
    'careerum-media-kit-footer',

    'careerum-reviews2-main',
    'careerum-reviews2-neuro',

    'careerum-alumni-main',
    'careerum-alumni-header',
    'careerum-alumni-schedule',
    'careerum-alumni-author',
    'careerum-alumni-master',
    'careerum-alumni-ai',
    'careerum-alumni-reviews',
    'careerum-alumni-tariffs',
    'careerum-alumni-main2',
    'careerum-alumni-what',
    'careerum-alumni-tariffs2',
    'careerum-alumni-banner',

    'careerum-bigpack_career-main',
    'careerum-bigpack_career-who',
    'careerum-bigpack_career-letters',
    'careerum-bigpack_career-result',
    'careerum-bigpack_career-form',
    'careerum-bigpack_career-thanks',

    'careerum-media-kit2-nav',
    'careerum-media-kit2-hero',
    'careerum-media-kit2-marks',
    'careerum-media-kit2-audience',
    'careerum-media-kit2-topics',
    'careerum-media-kit2-reviews',
    'careerum-media-kit2-video',
    'careerum-media-kit2-media',
    'careerum-media-kit2-bio',
    'careerum-media-kit2-photos',
    'careerum-media-kit2-booking',
    'careerum-media-kit2-footer',

    'careerum-media-kit2-nav--en',
    'careerum-media-kit2-hero--en',
    'careerum-media-kit2-marks--en',
    'careerum-media-kit2-angles--en',
    'careerum-media-kit2-quotes--en',
    'careerum-media-kit2-proof--en',
    'careerum-media-kit2-bio--en',
    'careerum-media-kit2-photos--en',
    'careerum-media-kit2-booking--en',
    'careerum-media-kit2-footer--en'
    
];

export default classNames;